import React from "react";
import s from "./LessonEndsWithVideoModal.module.scss";
import Modal from "components/common/Modal";
import Button from "../../common/Button";
import {play,} from "../../../redux/lesson/lessonActions";
import {lessonPageUrlFragment} from "../../../config/config";
import Lesson from "../../../models/view/lessonPage/Lesson";
import Segment from "../../../models/view/lessonPage/Segment";
import {useAppSelector} from "../../../redux/hooks";
import {lessonPlayerStore} from "../../../redux/lesson/LessonPlayerStore";
import {useNavigate} from "react-router-dom";

export interface ILessonEndsWithVideoModalProps {
  nextLessonId?: number;
  isLastSegmentOfLesson: boolean;
  isLastLessonOfSection: boolean;
}

export default function LessonEndsWithVideoModal({nextLessonId, isLastSegmentOfLesson, isLastLessonOfSection}: ILessonEndsWithVideoModalProps) {
  const navigate = useNavigate();
  const shouldDisplayLessonEndsWithVideoModal = useAppSelector(lessonPlayerStore.getDisplayLessonEndsWithVideoModal);

  const lesson = useAppSelector(lessonPlayerStore.getLesson);
  const segment = useAppSelector(lessonPlayerStore.getSegment);

  if (!shouldDisplayLessonEndsWithVideoModal) {
    return null;
  }

  const hideModalAndNavigate = (link: string, replaceCurrentHistoryEntry: boolean = false) => {
    hideModal();
    navigate(link, { replace: replaceCurrentHistoryEntry });
  }

  const nextButton = getNextButton(isLastSegmentOfLesson, isLastLessonOfSection, hideModalAndNavigate, lesson, segment, nextLessonId);

  return (
    <Modal onClose={()=> hideModal()} midiCloseShortcutNote={"B"}>
      <div className={s.lessonEndsWithVideoModal}>
        <h2 className={s.modalTitle}>Segment complete!</h2>
        <div className={s.actionButtons}>
          <Button
            text={'Replay'}
            ariaLabel={'Replay this segment'}
            navigationNote={'C'}
            buttonType={"primary"}
            onClick={() => hideLessonCompleteModalAndPlayAgain()}
          />
          {nextButton}
        </div>
      </div>
    </Modal>
  );
}

function getNextButton(isLastSegmentOfLesson: boolean, isLastLessonOfSection: boolean, hideModalAndNavigate: (link: string, replaceCurrentHistoryEntry: boolean) => void, lesson?: Lesson, segment?: Segment, nextLessonId?: number) {
  if (!lesson || !segment) {
    return null;
  }

  const segmentIndex = lesson.segments.findIndex((s) => s.id === segment.id && s.mode === segment.mode) ?? -1;
  const hasNextSegment = segmentIndex >= 0 && segmentIndex < lesson.segments.length - 1;

  let nextSegmentButton = null;

  if (hasNextSegment) {
    nextSegmentButton = <Button
      text={'Next'}
      ariaLabel={'Go to the next segment'}
      navigationNote={'D'}
      buttonType={"secondary"}
      additionalClassName={'secondaryOutlined'}
      onClick={() => {
        hideModalAndNavigate(`/lesson/${lesson.id}/${lesson.segments[segmentIndex + 1].id}`, true);
      }}
    />;
  }

  const nextLessonButton = nextLessonId
    ? <Button
      text={isLastLessonOfSection ? 'Next Section' : 'Next Lesson'}
      ariaLabel={'Go to the next lesson'}
      navigationNote={'D'}
      buttonType={"secondary"}
      additionalClassName={'secondaryOutlined'}
      onClick={() => {
        hideModalAndNavigate(lessonPageUrlFragment + nextLessonId.toString(), true);
      }}
    />
    : null;

  const nextButton = isLastSegmentOfLesson ? nextLessonButton : nextSegmentButton;
  return nextButton;
}

function hideLessonCompleteModalAndPlayAgain(){
  play();
  hideModal();
}

function hideModal() {
  lessonPlayerStore.setDisplayLessonEndsWithVideoModal(false);
}
